import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export class DeleteChat extends Component {

    constructor(props) {
        super(props);
        this.state = {


        };

        this.toggleModal = this.toggleModal.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);

    }

    toggleModal() {
        this.props.toggle();
    }


    confirmDelete(e) {
        e.preventDefault();
        this.props.toggle();
        var interactionThreadID = this.props.thread.InteractionThreadID;

        this.props.deleteChat(interactionThreadID);
    }


    render() {
        
        return (

            <Modal isOpen={this.props.isOpen} toggle={this.toggleModal} className={this.props.className}>
                <ModalHeader toggle={this.toggleModal}>Delete</ModalHeader>
                <ModalBody>
                   Are you sure you want to delete?
 
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" className="btn btn-rounded" onClick={this.toggleModal}>Close</Button>
                    <Button color="primary" className="btn btn-rounded" onClick={this.confirmDelete}>Delete</Button>{' '}
                </ModalFooter>
            </Modal>

        );
    }


}
